<template>
  <div class="img-upload" :class="url ? '':'border'" :style="`width:${boxWidth}px;height:${boxHeight}px; margin-bottom: ${imgName ? 20 : 0}px  `">
    <template v-if="url">
      <img class="img" :src="url" alt="img">
      <div class="hover">
        <i class="el-icon-zoom-in icon" @click="handleImgClick"></i>
        <i v-if="!disabled" class="el-icon-delete icon del-icon" @click="handleRemove"></i>
      </div>
    </template>
    <input v-if="!url && !disabled" :accept="accept" class="input" type="file" @change="handleChange">
    <i v-if=" !uploading && !url " class="el-icon-plus plus-icon"></i>
    <el-tooltip class="item" effect="dark" :open-delay="500" :content="imgName" placement="top">
      <p v-if="imgName" class="img-name">{{ imgName }}</p>
    </el-tooltip>
  </div>
</template>

<script>
// import { imageUploadApi } from './fetch'
import { uploadFile, isImageFile } from 'src/utils/upload'

import ImageFullScreen from '@/widget/Viewer'
export default {
  name: 'SingleUpload',
  props: {
    value: String,
    boxWidth: String,
    boxHeight: String,
    maxSize: {
      type: Number,
      default: 10 * 1024 * 1024,
    },
    accept: {
      type: String,
      default: 'image/*',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    remove: Boolean,
    imgName: String,
  },
  data () {
    return {
      url: '',
      percent: 0,
      uploading: false,
      width: undefined,
      height: undefined,
      imageShow: '',
    }
  },
  watch: {
    url (newVal, oldVal) {
      this.$emit('input', newVal)
      this.dispatch('ElFormItem', 'el.form.change', [newVal])
    },
    value: {
      handler: function (val) {
        this.url = val
        val && this.getImgHW(val)
      },
      immediate: true,
    },
    imageShow (val) {
      this.$emit('imgShow', this.imageShow)
    },
  },
  methods: {
    getFileSuffix (name) {
      const i = name.lastIndexOf('.')
      if (i < 0) return ''
      return name.slice(i + 1).toLowerCase()
    },
    getImgHW (file) {
      const that = this
      const url = window.URL || window.webkitURL
      const img = new Image() // 手动创建一个Image对象
      if (typeof file === 'string') {
        // 改变图片的src
        img.src = file
      } else {
        img.src = url.createObjectURL(file)// 创建Image的对象的url
      }
      img.onload = function () {
        that.height = this.height
        that.width = this.width
        that.$emit('getImageSize', this.width, this.height)
      }
    },
    // 图片上传
    async handleChange ({ target }) {
      try {
        const { maxSize } = this
        const file = target.files[0]
        // 图片宽高获取
        // 校验大小
        if (file.size > maxSize) {
          const output = maxSize < 1024 * 1024 ? `${maxSize / 1024}K` : `${maxSize / 1024 / 1024}M`
          this.$warn('图片大小不能大于' + output)
          return
        }
        if (!isImageFile(file)) {
          throw new Error('请选择图片文件（支持常见图片格式）')
        }
        this.getImgHW(file)

        this.uploading = true
        this.url = await uploadFile(file)

        this.imageShow = true
      } catch (e) {
        this.$error(e)
      } finally {
        this.uploading = false
        target.value = ''
      }
    },
    // 图片删除
    handleRemove () {
      this.url = ''
      this.imageShow = false
    },
    // 图片查看
    handleImgClick () {
      if (this.url) {
        ImageFullScreen({
          list: [{ url: this.url }],
          itemKey: 'url',
          index: 0,
        })
      }
    },
    dispatch (componentName, eventName, params) {
      var parent = this.$parent || this.$root
      var name = parent.$options.componentName
      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent
        if (parent) {
          name = parent.$options.componentName
        }
      }
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params))
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.img-upload{
  width: 82px;
  height: 82px;
  position: relative;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &.border{
    border: 1px dashed #DCDFE6;
  }
}
.img-upload .img{
  width: 100%;
  height: 100%;
  border-radius: 4px;
  // cursor: zoom-in;
}
.img-upload .process{
  padding: 20px;
}
.img-upload .input{
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  cursor: pointer;
}
.img-upload .plus-icon {
  font-size: 24px;
  color: #c0c4cc;
}
.img-upload:hover{
  .hover{
    display: flex;
  }
}
.hover{
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  color: #409eff;
  font-size: 18px;
  border-radius: 4px;
  background-color: rgba(0,0,0,.6);
  align-items: center;
  justify-content: center;
  .icon{
    cursor: pointer;
  }
  .del-icon{
    margin-left: 5px;
  }
}
.delete-icon {
  font-size: 24px;
  color: #333;
  position: absolute;
  top: -10px;
  right: -10px;
}
.img-name {
  width:100%;
  position:absolute;
  transform:translate(-50%,0);
  bottom: -30px;
  left: 50%;
  font-size: 12px;
  @include ellipsis(1);
  text-align: center;

}
</style>
